export const toggleView = () => {
  const btnToggleView = document.querySelectorAll(".js-view-toggle");
  const viewContainer = document.querySelector(".js-view-container");
  const body = document.body;

  // Initialize based on URL parameter
  const init = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const view = urlParams.get("view");

    // If the URL parameter specifies night, initialize as night view
    if (view === "night") {
      body.classList.add("is-inverted");
      viewContainer.setAttribute("data-view", "night");
      body.setAttribute("data-current-view", "night");
      setActiveButton("night");
    } else {
      // Default to day view if no parameter or if day is specified
      body.classList.remove("is-inverted");
      viewContainer.setAttribute("data-view", "day");
      body.setAttribute("data-current-view", "day");
      setActiveButton("day");
    }

    bind();
  };

  // Function to set the active class on the corresponding button
  const setActiveButton = (viewToToggle) => {
    btnToggleView.forEach((button) => {
      button.classList.toggle(
        "is-active",
        button.getAttribute("data-view") === viewToToggle
      );
    });
  };

  // Bind event listeners to the toggle buttons
  const bind = () => {
    btnToggleView.forEach((btn) => {
      btn.addEventListener("click", function (e) {
        e.preventDefault();

        // Update the active button
        btnToggleView.forEach((button) => button.classList.remove("is-active"));
        this.classList.add("is-active");

        // Set data-view attribute on the container and current view on body
        const viewToToggle = this.getAttribute("data-view");
        viewContainer.setAttribute("data-view", viewToToggle);
        body.setAttribute("data-current-view", viewToToggle);

        // Toggle is-inverted class based on data-view
        if (viewToToggle === "night") {
          body.classList.add("is-inverted");
        } else {
          body.classList.remove("is-inverted");
        }
      });
    });
  };

  init();
};
